import * as constants from "@/mixin/constants";

var platform = require("platform");
var crypto = require("crypto");

/**
 * 共通処理
 */
export default {
  methods: {
    /**
     * ログ出力
     */
    log: function(message) {
      // 開発環境のときだけ、ログ出力
      var env = process.env.DEPLOY_ENV;
      if (env !== "production") {
        console.log(message);
      }
    },
    /**
     * 指定されたコンテンツの画像パスを取得する
     *
     * @param {String} contentId コンテンツID
     * @param {String} showScreen 当メソッドを呼び出した画面のタイプ
     * @param {String} gridType ストア一覧画面での画像出力位置(未指定可)
     * @return {String} コンテンツ画像パス
     */
    getContentsThumbnailPath: function(contentId, showScreen, gridType) {
      var self = this;
      var isMobile = window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME);
      var picName;

      self.log("getContentsThumbnailPath showScreen: " + showScreen);
      self.log("getContentsThumbnailPath isMobile: " + isMobile);
      self.log("getContentsThumbnailPath gridType: " + gridType);
      switch (showScreen) {
        case "PurchasedList":
        case "PortalList":
          if (isMobile) {
            picName = "thumb.jpg";
          } else {
            picName = "thumb_wide.jpg";
          }
          break;
        case "PurchasedDetail":
        case "StoreDetail":
          if (isMobile) {
            picName = "thumb_ratio43.jpg";
          } else {
            picName = "thumb_vertical.jpg";
          }
          break;
        case "StoreListItem":
          if (gridType == "group1") {
            if (isMobile) {
              picName = "thumb_l_sp.jpg";
            } else {
              picName = "thumb_l.jpg";
            }
          } else if (gridType == "group2_grid1") {
            if (isMobile) {
              picName = "thumb_m_sp.jpg";
            } else {
              picName = "thumb_m.jpg";
            }
          } else {
            if (isMobile) {
              picName = "thumb_s_sp.jpg";
            } else {
              picName = "thumb_s.jpg";
            }
          }
          break;
        default:
          picName = "default.jpg";
          break;
      }

      return this.getContentsResourcesPath(contentId) + "/images/" + picName;
    },
    /**
     * 指定されたコンテンツの概要テキストのパスを取得する
     *
     * @param {String} contentId コンテンツID
     * @return {String} コンテンツ概要ファイルパス
     */
    getContentsOverviewPath: function(contentId) {
      return this.getContentsResourcesPath(contentId) + "/overview.txt";
    },
    /**
     * 指定されたコンテンツのリソースフォルダパスを取得する
     *
     * @param {String} contentId コンテンツID
     * @return {String} コンテンツリソースフォルダパス
     */
    getContentsResourcesPath: function(contentId) {
      if (process.env.NODE_ENV == "development") {
        // 開発環境の場合はステージング環境のオリジンでパス文字列を生成する
        return "https://test.rosettastone-apps.jp/library/resources/" + contentId;
      } else {
        return "resources/" + contentId;
      }
    },
    /**
     * 指定されたテキストファイルの内容を取得
     *
     * @param {String} url 対象ファイルのURL
     * @return {Promise} resolve:テキストファイルの内容
     */
    getTextFileData: function(url) {
      var self = this;

      self.log("getTextFileData start url: " + url);
      return new Promise(function(resolve) {
        var xmlHttp = new XMLHttpRequest();

        xmlHttp.onreadystatechange = function() {
          // データ受信完了
          if (xmlHttp.readyState == 4) {
            var result = "";
            var status = xmlHttp.status;
            self.log("getTextFileData HttpStatus: " + status);
            if (status == 200) {
              if (/^.*\.txt$/.test(url)) {
                result = xmlHttp.responseText;
              }
              self.log("getTextFileData responseText: " + result);
            }
            self.log("getTextFileData end");
            resolve(result);
          }
        };

        xmlHttp.open("GET", url, true);
        xmlHttp.send(null);
      });
    },
    /**
     * Safariのログイン、シリアル、ローディング画面のブラウザ縮小時の高さ調整
     */
    fixtHeightForSafariFullWindow: function() {
      var windowHeight = window.innerHeight;
      $("body").css("height", windowHeight + "px");
      $(".inner.flexcenter").css("height", windowHeight + "px");

      $(window).resize(function() {
        var windowHeight = window.innerHeight;
        $("body").css("height", windowHeight + "px");
        $(".inner.flexcenter").css("height", windowHeight + "px");
      });
    },
    /**
     * 非表示コンテンツか否かを返す
     *
     * @param {String} コンテンツID
     *
     * @return {Boolean} true：非表示コンテンツ, false：表示コンテンツ
     */
    isInvisibleContent: function(contentId) {
      var invisibles = constants.INVISIBLE_CONTENTS[process.env.DEPLOY_ENV][window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME) ? "mobile" : "pc"];
      return invisibles.some(function(invisible) { return contentId == invisible; });
    },
    /**
     * 使用プラットフォームがDocomoかを判定する
     */
    isDocomo: function(platformName) {
      if (platformName === constants.PLATFORM_DOCOMO) {
        return true;
      }
      return false;
    },
    /**
     * 使用プラットフォームがauかを判定する
     */
    isAu: function(platformName) {
      if (platformName === constants.PLATFORM_AU) {
        return true;
      }
      return false;
    },
    /**
     * 使用プラットフォームがsoftbankかを判定する
     */
    isSoftbank: function(platformName) {
      if (platformName === constants.PLATFORM_SOFTBANK) {
        return true;
      }
      return false;
    },
    /**
     * 使用プラットフォームがキャリア版かを判定する
     */
    isCarrier: function(platformName) {
      return this.isDocomo(platformName) || this.isAu(platformName) || this.isSoftbank(platformName);
    },
    /**
     * 使用プラットフォームがiOSかを判定する
     */
    isPlatformiOS: function(platformName) {
      if (platformName === constants.PLATFORM_IOS) {
        return true;
      }
      return false;
    },
    /**
     * 使用プラットフォームがライブラリ版Androidかを判定する
     */
    isLibraryAndroid: function(platformName) {
      if (platformName === constants.PLATFORM_LIBRARY) {
        return true;
      }
      return false;
    },
    /**
     * 使用ブラウザがIEかを判定する
     *
     * @return {Boolean} true: IE, false: IE以外
     */
    isIE: function() {
      if (this.isEnvironmentPc() && platform.name == "IE") {
        return true;
      }
      return false;
    },
    /**
     * ユーザ登録状態取得処理
     */
    getUserRegistrationInfo: function() {
      this.log("common start getUserRegistrationInfo");
      const self = this;

      if (!this.isPlatformiOS(this.platformName)) {
        return;
      }

      new Promise(function(resolve, reject) {
        const promiseId = storage_wrapper.getPromiseId();
        handlers[promiseId] = { resolve: resolve, reject: reject };
        window.Phone.GetUserRegistrationInfo(promiseId);
      }).then(function(isRegistered) {
        self.$emit("setIsRegistered", isRegistered);
      });
    },
    /**
     * 実行環境がPCの場合trueを返却する
     */
    isEnvironmentPc: function() {
      var p = window.hasOwnProperty("Phone");
      if (p) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * bodyにclass'modal-open'を追加し、モーダル画面表示中のスクロールを不可にする
     *
     * @param {Boolean} add trueの場合は追加、falseの場合は削除
     */
    setBodyStylePosition: function(add) {
      if (add) {
        window.scrollY = window.pageYOffset;
        window.document.getElementsByTagName("body")[0].classList.add("modal-open");
        window.document.body.style.top = -1 * window.scrollY + "px";
      } else {
        window.document.getElementsByTagName("body")[0].classList.remove("modal-open");
        window.document.body.style.top = "";
        window.scrollTo(0, window.scrollY);
      }
    },
    /**
     * 指定された平文のSHA256ハッシュ値をHEX文字列で取得する
     *
     * @param {String} plainText 平文
     *
     * @return {String} 指定された平文のSHA256ハッシュ値のHEX文字列
     */
    getSha256HashHexString: function(plainText) {
      var hash = crypto.createHash("sha256");
      hash.update(plainText);
      return hash.digest("hex");
    },
    /**
     * 特定のタグを文字列に変換する
     * ※例：<ant>text</ant> ⇒ 【反意語】text
     *
     * @param {String} str 変換対象の文字列
     *
     * @return {String} 変換後の文字列
     */
    changeTag: function(str) {
      var changeStr = str;
      if (str == null) {
        return changeStr;
      }

      for (var i = 0; i < constants.DIC_CHANGE_TAG_LIST.length; i++) {
        const tagName = constants.DIC_CHANGE_TAG_LIST[i]["tag"];
        const changeWord = constants.DIC_CHANGE_TAG_LIST[i]["word"];
        const pattern = new RegExp("<" + tagName + ".*?>(.*?)</" + tagName + ">", "gim");
        changeStr = changeStr.replace(pattern, changeWord + "$1");
      }

      return changeStr;
    },
    /**
     * アクセス可能なURLかを判定する
     *
     * @param {String} url 判定対象のURL
     *
     * @return {Promise} resolve:判定結果 true:アクセス可, flase:アクセス不可
     */
    isAccessUrl: function(url) {
      const self = this;
      this.log("Start isAccessUrl url: " + url);
      return new Promise(function(resolve, reject) {
        $.ajax({
          url: url
        }).done(function(data, status, xhr) {
          var status_code = xhr.status;
          if (status_code === 200) {
            self.log("Success isAccessUrl status_code: " + status_code);
            resolve(true);
          } else {
            self.log("Error isAccessUrl status_code: " + status_code);
            resolve(false);
          }
        }).fail(function(xhr, status, err) {
          var status_code = xhr.status;
          self.log("Error isAccessUrl status_code: " + status_code);
          resolve(false);
        });
      });
    },
    /**
     * 実行環境に応じたイベントカテゴリを取得する
     *
     * @param {String} eventCategory イベントカテゴリ
     * @param {String} platformName 実行環境
     */
    getGaEventCategoryByPlatformName: function(eventCategory, platformName) {
      if (this.isDocomo(platformName)) {
        return eventCategory + constants.GA_EVENT_GATEGORY_WITH_STRING.DOCOMO;
      }
      if (this.isAu(platformName)) {
        return eventCategory + constants.GA_EVENT_GATEGORY_WITH_STRING.AU;
      }
      return eventCategory;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/common.js